import { AiOutlineInstagram } from "react-icons/ai";
import { AiOutlineDribbble } from "react-icons/ai";
import { AiFillGithub } from "react-icons/ai";
import { FaXTwitter } from "react-icons/fa6";

const data = [
    {id: 1, link: 'https://www.instagram.com/adekunlefaizoladebayo/', icon: <AiOutlineInstagram/>},
    {id: 2, link: 'https://x.com/faizytech001', icon: <FaXTwitter/>},
    {id: 3, link: 'https://dribbble.com/faizytech', icon: <AiOutlineDribbble/>},
    {id: 4, link: 'https://github.com/faizy0034/', icon: <AiFillGithub/>}

]

export default data